import { useContextState } from "../../../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            padding: 3,
            borderTop: `1px ${colors.color13} solid`,
            borderBottom: `1px ${colors.color13} solid`,
            display: 'flex',
            width: '100%',
            flexWrap: 'wrap',
            gap: 3
        },
        titleContainer: {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        settingContainer: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
        },
        settingContainerCatalog: {
            width: '100%',
            display: 'flex',
            alignItems: 'start',
            '& .MuiButtonBase-root':{
                marginTop: 1
            },
            gap: 1,
        },
        optionTitle: {
            fontWeight: 'medium',
            fontSize: '14px'
        },
        options: {
            //width: '100%',
            justifyContent: 'end',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            '& .MuiButton-root': {
                borderRadius: '40px'
            },
            '& .MuiButton-outlined': {
                borderColor: colors.color13,
                color: colors.color13,
                '&:hover': {
                    borderColor: colors.color13,
                    color: colors.color13,
                },
            },
            '& .MuiButton-contained': {
                backgroundColor: colors.color13,
                color: colors.color5,
                '&:hover': {
                    backgroundColor: colors.color13,
                    color: colors.color5
                },
            }
        },
        title: {
            fontWeight: 'bold'
        }
    }
}

export { useStyles }
